export const setWizardStepReducer = (prev, update) => {
    return { ...prev, activeStep: update.step };
};
export const setWizardAllowNextReducer = (prev, update) => {
    return { ...prev, allowNext: update.allowNext };
};
export const setWizardAllowBackReducer = (prev, update) => {
    return { ...prev, allowBack: update.allowBack };
};
